/**
 * @generated SignedSource<<433437f8984db1f87e99e6534db6f2d7>>
 * @relayHash 1d3ac54d7ee746155eab3922887ae845
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 63145884bb9041214fe3460df121f3c176229f55baa620e32e723f8283d86dee

import type { ConcreteRequest, Query } from 'relay-runtime';
export type mainArcivedIssuesProjectNameQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type mainArcivedIssuesProjectNameQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly __typename: "JiraProject";
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
};
export type mainArcivedIssuesProjectNameQuery = {
  response: mainArcivedIssuesProjectNameQuery$data;
  variables: mainArcivedIssuesProjectNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v2 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
          }
        ],
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jiraProjectByKey",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainArcivedIssuesProjectNameQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainArcivedIssuesProjectNameQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "63145884bb9041214fe3460df121f3c176229f55baa620e32e723f8283d86dee",
    "metadata": {},
    "name": "mainArcivedIssuesProjectNameQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7697dc80c1c8d6b9f572e8750cb6c130";

export default node;
